/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import userApi from 'api/user.api';
import { createFOAsyncThunk } from '../../../helpers/thunk.helpers';

/* Thunks */
export const getOrganizationById = createFOAsyncThunk('organizationEditor/getOrganizationById', async organizationId =>
  userApi.getOrganizationById(organizationId),
);

export const saveOrganization = createFOAsyncThunk(
  'organizationEditor/saveOrganization',
  async organizationRequestObj => userApi.create(organizationRequestObj),
);

export const editOrganization = createFOAsyncThunk(
  'organizationEditor/editOrganization',
  async ({ orgId, organization }) => userApi.editOrganization(orgId, organization),
);
